$(document).ready(function () {
    $('.module-post_listings').each(function () {
        let el = $(this);
        let currentpage = el.data('currentpage');
        let maxpage = el.data('maxpage');
        let listings = el.find('.listings');
        let type = el.data('type');

        // Load More Button
        el.find($('.loadmore')).click(function () {
            let button = $(this),
                data = {
                    'action': 'loadmore',
                    'post_type': type,
                    'page': currentpage,
                    'filter': el.data('filters'),
                };

            $.ajax({
                url: '/wp-admin/admin-ajax.php', // AJAX handler
                data: data,
                type: 'POST',
                beforeSend: function (xhr) {
                    button.text('Loading...'); // change the button text, you can also add a preloader image
                },
                success: function (data) {
                    if (data) {
                        button.text('Load More');

                        let html = data;

                        $(html).appendTo(listings).hide().fadeIn(500); // insert new posts

                        el.data('currentpage', currentpage++);

                        if (currentpage === maxpage)
                            button.remove(); // if last page, remove the button

                        // you can also fire the "post-load" event here if you use a plugin that requires it
                        // $( document.body ).trigger( 'post-load' );
                    } else {
                        button.remove(); // if no data, remove the button as well
                    }
                },
            });
        })

        // Filter button
        el.find($('.filter-item')).click(function () {
            let filteritem = $(this);
            let button = $('.loadmore'),
                data = {
                    'action': 'postfilter',
                    'filter': filteritem.data('filter'),
                    // eslint-disable-next-line no-undef
                    'post_type': el.data('type'),
                };

            // Clear active states and ser this as active
            $('.filter-item').removeClass('active');
            filteritem.addClass('active');

            $.ajax({
                url: '/wp-admin/admin-ajax.php', // AJAX handler
                data: data,
                dataType: 'JSON',
                type: 'POST',
                success: function (data) {
                    currentpage = 1;

                    // set the new query parameters
                    maxpage = data.max_page;

                    // insert into container
                    listings.html(data.content);

                    // set filter
                    el.data('filters', filteritem.data('filter'));

                    if (maxpage < 2 ) {
                        button.hide();
                    } else {
                        button.show();
                    }
                },
            });
        });
    });
});
